import {
	captureCampaignFromRoute,
	refreshCampaignActivity
} from '~/composables/adCampaign/utils';

export default defineNuxtRouteMiddleware(to => {
	if (import.meta.client) {
		captureCampaignFromRoute(to);
		refreshCampaignActivity();
	}
});
